import { useContext, useEffect, useState, useRef } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';

import {
  Container,
  Form,
  Image,
  Nav,
  Navbar,
  NavDropdown,
  Dropdown,
  DropdownButton,
  Button,
  Modal
} from 'react-bootstrap';
import { ImExit } from 'react-icons/im';
import { BsQuestionCircle } from 'react-icons/bs';

import styles from './Header.module.css';
import { UserContext } from '../../context/UserContext';
import { decrypt } from '../../helpers/cryptography';
import criarCategoria from '../../api/doc/criarCategoria';
import getCategorias from '../../api/doc/getCategorias';
import fesaudeLogo3 from '../../assets/img/fesaude-logo3.png';
import CAPS from '../../constants/caps';

const Header = () => {
  const location = useLocation();
  const navRef = useRef(null);
  const history = useHistory();
  const {
    login,
    userLogout,
    isAdmin,
    isConsulta,
    isOuvidoriaConsulta,
    isCapsAdmin,
    isCapsSupervisor,
    isCapsOperador,
    isCapsConsulta,
    isTodosCapsConsulta,
    isMdi,
    isPesquisa,
    isReducaoDeDanos,
    isReducaoConsulta,
    isInscricaoAdmin,
    isDocsDas,
    isDocsDiti,
    isDocsDaf,
    isDocsDtec,
    isDocsDg,
    isVest,
    isCecoAdmin,
    isCecoOperador,
    isAtivAdmin,
    isAtivOperador,
    isAtivConsulta,
    isLeitos,
    isLeitosUai,
    isLeitosUaa,
    isLeitosCapsAd,
    isTodosLeitosConsulta,
    isConselhoCurador,
    isTreinamento,
    isCec,
    isSuprimentosAdmin,
    isSuprimentosOperador,
    isSuprimentosConsulta
  } = useContext(UserContext);

  const [avatar, setAvatar] = useState('');
  const [isInscricao, setIsInscricao] = useState(false);
  const [edital, setEdital] = useState('');
  const [inscricaoToken, setInscricaoToken] = useState(null);
  const [showIpssModal, setShowIpssModal] = useState(false);
  const [showCategoriaModal, setShowCategoriaModal] = useState(false);
  const [diretoria, setDiretoria] = useState('');
  const [categoria, setCategoria] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [refreshMessage, setRefreshMessage] = useState('');
  const [showModalRefresh, setShowModalRefresh] = useState(false);

  const categoriaRef = useRef(null);

  const handleIpssModalClose = () => setShowIpssModal(false);
  const handleCategoriaModalClose = () => setShowCategoriaModal(false);
  const handleModalRefreshClose = () => setShowModalRefresh(false);

  useEffect(() => {
    if (location.pathname.split('/').includes('inscricao')) {
      setIsInscricao(true);
      setEdital(location.pathname.split('/')[2]);

      const incToken = localStorage.getItem('inscricao_token');

      if (incToken) {
        setInscricaoToken(incToken);
      }
    } else {
      setIsInscricao(false);
      setEdital('');
    }
  }, [location, location.pathname]);

  const inscricaoLogout = () => {
    localStorage.removeItem('inscricao_token');
    localStorage.removeItem('inscricao');

    setInscricaoToken(false);

    history.push(`/inscricao/${edital}`);
  };

  const logout = () => {
    userLogout();

    window.localStorage.removeItem('login');
    window.localStorage.removeItem('token');

    handleCollapse();

    history.push('/');
  };

  const goToHome = () => {
    handleCollapse();

    history.push('/');
  };

  useEffect(() => {
    if (localStorage.getItem('login')) {
      const user = JSON.parse(localStorage.getItem('login'));
      const name = decrypt(user?.user?.name);
      const names = name.split(' ');
      const initial1 = names[0][0];
      const initial2 = names[names.length - 1][0] || initial1;
      const initials = initial1 + initial2;

      setAvatar(initials);
    }
  }, [login]);

  const handleCollapse = () => {
    navRef?.current?.classList?.toggle('show');
  };

  useEffect(() => {
    const getAllCategorias = async () => {
      const response = await getCategorias();

      setCategorias(response);
    };

    getAllCategorias();
  }, [refreshMessage]);

  const handleNavLinks = {
    caps: {
      cadastroPaciente() {
        history.push('/caps');
        handleCollapse();
      },
      reducaoDanos() {
        history.push('/acoes-territoriais');
        handleCollapse();
      },
      cccn() {
        history.push('/ceco');
        handleCollapse();
      },
      gestaoDeLeitos() {
        history.push('/gestao-leitos');
        handleCollapse();
      },
    },
    documentos: {
      docsLinks(diretoria, categoria) {
        history.push(`/docs/${diretoria}/${categoria}`);
        handleCollapse();
      }
    },
    gestao: {
      mdi() {
        history.push('/monitoramento');
        handleCollapse();
      },
      pesquisa() {
        history.push('/pesquisa-grafico');
        handleCollapse();
      },
      ouvidoria() {
        history.push('/ouvidoria');
        handleCollapse();
      },
      inscricao() {
        history.push('/inscricao-admin');
        handleCollapse();
      },
      vestuario() {
        history.push('/vestuario');
        handleCollapse();
      },
      atividades() {
        history.push('/atividades-educativas');
        handleCollapse();
      },
      treinamentos() {
        history.push('/treinamentos');
        handleCollapse();
      },
      treinamentosAdmin() {
        history.push('/treinamentos/admin');
        handleCollapse();
      },
      controleEquipamentos() {
        history.push('/controle-equipamentos');
        handleCollapse();
      },
    },
    mapaDaRede: {
      rede() {
        history.push('/mapa/rede');
        handleCollapse();
      },
      capsAd() {
        history.push('/mapa/capsad');
        handleCollapse();
      },
      capsCasaDoLargo() {
        history.push('/mapa/capscasadolargo');
        handleCollapse();
      },
      capsHerbertDeSouza() {
        history.push('/mapa/capsherbertdesouza');
        handleCollapse();
      },
      capsiMonteiroLobato() {
        history.push('/mapa/capsimonteirolobato');
        handleCollapse();
      },
      raps() {
        history.push('/mapa/raps');
        handleCollapse();
      },
      dadosAssistenciais() {
        history.push({
          pathname: '/bi',
          state: { biUrl: 'https://app.powerbi.com/view?r=eyJrIjoiMDhiOWM4NTctNDA3YS00ZDY5LWI5MWUtZTI4YjllNGY5ZmU4IiwidCI6IjY3N2U1MjZlLTZhMzAtNGNjMC05MGU3LWMzYWQ0YTk1N2U4NSJ9' }
        });
        handleCollapse();
      }
    },
    user: {
      admin() {
        history.push('/admin');
        handleCollapse();
      },
      manual() {
        history.push({
          pathname: link,
          target: '_blank',
        });
      }
    },
    eleicao: {
      listagemCipaa() {
        history.push('/cipaa/lista');
        handleCollapse();
      },
      apuracaoCipaa() {
        history.push('/cipaa/apuracao');
        handleCollapse();
      },
      listagemConselhoCurador() {
        history.push('/conselho-curador/lista');
        handleCollapse();
      },
      apresentacaoConselhoCurador() {
        history.push('/conselho-curador/apresentacao');
        handleCollapse();
      },
      votacaoConselhoCurador() {
        history.push('/conselho-curador/votacao');
      },
      apuracaoConselhoCurador() {
        history.push('/conselho-curador/apuracao');
        handleCollapse();
      },
    },
    suprimentos: {
      cadastro() {
        history.push('/suprimentos');
        handleCollapse();
      },
    }
  }

  const link = isConsulta ? 'http://189.112.226.76:3000/assets/pdfs/manual-sisged.pdf' : 'http://189.112.226.76:3000/assets/pdfs/manual-sisged.pdf';

  const adicionarCategoria = diretoria => {
    setDiretoria(diretoria);
    setShowCategoriaModal(true);
  };

  const handleCreateCategory = async e => {
    e.preventDefault();
    setIsLoading(true);

    await criarCategoria(diretoria, categoria.trim());

    setIsLoading(false);
    setCategoria('');
    setShowCategoriaModal(false);
    setRefreshMessage(`Categoria "${categoria.trim()}" criada com sucesso!`);
    setShowModalRefresh(true);
  }

  const diretorias = {
    DAS: isDocsDas,
    DITI: isDocsDiti,
    DTEC: isDocsDtec,
    DAF: isDocsDaf,
    DG: isDocsDg
  };

  const isDiretoria = diretoria => diretorias[diretoria];

  useEffect(() => {
    if (categoriaRef.current) {
      categoriaRef.current.focus();
    }
  }, [showCategoriaModal]);

  return (
    <Navbar sticky="top" bg="primary" variant="dark" className={styles.bg} expand="lg" /* collapseOnSelect */ expanded={false}>
      <Container>
        <Navbar.Brand className={styles.brand} onClick={goToHome}>
          <Image
            width={200}
            height={74.2}
            src={fesaudeLogo3}
            fluid
            className={styles.logo_header}
          />
          <div className={styles.brand_divider} />
          <span className={styles.sis}>SisGeD</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleCollapse} />

        <Navbar.Collapse id="basic-navbar-nav" ref={navRef}>
          <Nav className={`ms-auto ${styles.font}`} defaultActiveKey="/">

            <NavDropdown
              title="Mapas da Rede"
              className={styles.dropdown}
            >
              <NavDropdown.Item
                className={styles.dropdown_item}
                onClick={handleNavLinks.mapaDaRede.rede}
              >
                Rede de Atenção à Saúde
              </NavDropdown.Item>

              {login && (
                <>
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.mapaDaRede.capsAd}
                  >
                    CAPS AD III Alcenir Veras
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.mapaDaRede.capsCasaDoLargo}
                  >
                    CAPS Martha e Dr. Jacinto
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.mapaDaRede.capsHerbertDeSouza}
                  >
                    CAPS Herbert de Souza
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.mapaDaRede.capsiMonteiroLobato}
                  >
                    {CAPS.CNES_3708330}
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.mapaDaRede.raps}
                  >
                    Usuários da RAPS
                  </NavDropdown.Item>
                </>
              )}

              <NavDropdown.Item
                className={styles.dropdown_item}
                onClick={handleNavLinks.mapaDaRede.dadosAssistenciais}
              >
                FeSaúde - Dados Assistenciais
              </NavDropdown.Item>
            </NavDropdown>

            { (isSuprimentosAdmin || isSuprimentosOperador || isSuprimentosConsulta) && (
              <NavDropdown
                title="Suprimentos"
                className={styles.dropdown}
              >
                <NavDropdown.Item
                  className={styles.dropdown_item}
                  onClick={handleNavLinks.suprimentos.cadastro}
                >
                  Cadastro
                </NavDropdown.Item>
              </NavDropdown>
              
            ) }


            {/* {login && (
              <NavDropdown
                title="Eleição"
                className={`${styles.dropdown} ${styles.dropdown_center}`}
              >
                {isConselhoCurador && (
                  <>
                    {isConselhoCurador && (
                      <NavDropdown.Item
                        className={styles.dropdown_item}
                        onClick={handleNavLinks.eleicao.listagemConselhoCurador}
                      >
                        Listagem Conselho Curador
                      </NavDropdown.Item>
                    )}
                  </>
                )}

                <NavDropdown.Item
                  className={styles.dropdown_item}
                  onClick={handleNavLinks.eleicao.apuracaoConselhoCurador}
                >
                  Apuração Conselho Curador
                </NavDropdown.Item>
              </NavDropdown>
            )} */}

            {login && (
              <NavDropdown
                title="Documentos"
                className={`${styles.dropdown} ${styles.dropdown_center}`}
              >
                <>
                  {categorias && categorias.length > 0 && categorias.map(item => (
                    <NavDropdown
                      key={item._id}
                      title={item.diretoria}
                      className={`mt-2 mr-2 ${styles.dropdown} ${styles.dropdown_color}`}
                      drop='end'
                    >
                      {isDiretoria(item.diretoria) && (
                        <NavDropdown.Item
                          className={styles.dropdown_item}
                          onClick={() => adicionarCategoria(`${item.diretoria}`)}
                        >
                          <Button size='sm' className={styles.dropdown_button}>
                            Adicionar categoria
                          </Button>
                        </NavDropdown.Item>
                      )}

                      {item.setor.map(i => (
                        <NavDropdown.Item
                          key={i.nome}
                          className={styles.dropdown_item}
                          onClick={() => handleNavLinks.documentos.docsLinks(item.diretoria, i.nome)}
                        >
                          {i.nome}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  ))}
                </>
              </NavDropdown>
            )}

            {login && (
              <NavLink
                className={styles.links}
                to="/solicitacoes?pagina=1"
                activeStyle={{ color: '#9CC4D5' }}
                onClick={handleCollapse}
              >
                Solicitação
              </NavLink>
            )}

            {login && (
              <NavDropdown
                title="Gestão"
                className={styles.dropdown}
              >
                {isOuvidoriaConsulta && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.gestao.ouvidoria}
                  >
                    Ouvidoria
                  </NavDropdown.Item>
                )}
                {isMdi && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.gestao.mdi}
                  >
                    MDI - Demandas Institucionais
                  </NavDropdown.Item>
                )}
                {isPesquisa && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.gestao.pesquisa}
                  >
                    Pesquisa de Satisfação
                  </NavDropdown.Item>
                )}
                {isInscricaoAdmin && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.gestao.inscricao}
                  >
                    Processo Seletivo
                  </NavDropdown.Item>
                )}
                {isVest && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.gestao.vestuario}
                  >
                    Vestuário
                  </NavDropdown.Item>
                )}
                {(isAtivAdmin || isAtivOperador || isAtivConsulta) && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.gestao.atividades}
                  >
                    Atividades Educativas
                  </NavDropdown.Item>
                )}
                {login && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.gestao.treinamentos}
                  >
                    Treinamentos
                  </NavDropdown.Item>
                )}

                {isCec && (
                  <NavDropdown.Item 
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.gestao.controleEquipamentos}
                  >
                    CEC - Controle de Equipamentos
                  </NavDropdown.Item>
                )}
                </NavDropdown>
            )}

            {(isCapsAdmin || isCapsSupervisor || isCapsOperador || isCapsConsulta || isTodosCapsConsulta || isLeitos || isLeitosUai || isLeitosUaa || isLeitosCapsAd || isTodosLeitosConsulta) && (
              <NavDropdown
                title="RAPS"
                className={styles.dropdown}
              >
                {(isCapsAdmin || isCapsSupervisor || isCapsOperador || isCapsConsulta || isTodosCapsConsulta) && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.caps.cadastroPaciente}
                  >
                    Cadastro de Pacientes
                  </NavDropdown.Item>
                )}
                {(isReducaoDeDanos || isReducaoConsulta) && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.caps.reducaoDanos}
                  >
                    Ações Territoriais/RD
                  </NavDropdown.Item>
                )}

                {(isCecoAdmin || isCecoOperador) && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.caps.cccn}
                  >
                    CeCo
                  </NavDropdown.Item>
                )}

                {(isLeitos || isLeitosUai || isLeitosUaa || isLeitosCapsAd || isTodosLeitosConsulta) && (
                  <NavDropdown.Item
                    className={styles.dropdown_item}
                    onClick={handleNavLinks.caps.gestaoDeLeitos}
                  >
                    Mapa de Ocupação
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            )}

            {!login && !isInscricao && (
              <NavLink
                className={styles.links}
                to="/login"
                activeStyle={{ color: '#9CC4D5' }}
                onClick={handleCollapse}
              >
                Login
              </NavLink>
            )}

            {(login && !inscricaoToken && isInscricao) && (
              <NavLink
                className={styles.links}
                to="/"
                onClick={logout}
              >
                Sair
              </NavLink>
            )}

            {isInscricao && (
              <>
                <Button variant="flat" className={styles.btn_links}>
                  <a
                    href="../../assets/pdfs/manual-processo-seletivo.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.links_a}
                  >
                    MANUAL
                  </a>
                </Button>

                <Button variant="flat" className={styles.btn_links} onClick={() => setShowIpssModal(true)}>
                  <BsQuestionCircle size={24} style={{ fontWeight: 'bold' }} />
                </Button>
              </>
            )}

            {isInscricao && inscricaoToken && (
              <Button
                variant="flat"
                className={styles.btn_links}
                onClick={inscricaoLogout}
              >
                SAIR <ImExit size={24} style={{ marginLeft: '10px' }} />
              </Button>
            )}
          </Nav>

          {login && (
            <DropdownButton title={avatar} className={styles.avatar_dropdown}>
              {isAdmin && (
                <Dropdown.Item className={styles.dropdown_item} onClick={handleNavLinks.user.admin}>Admin</Dropdown.Item>
              )}
              <Dropdown.Item className={styles.dropdown_item} href={link} target='_blank'>Manual</Dropdown.Item>
              <Dropdown.Divider style={{ borderTop: '2px solid #f1800a', opacity: '1' }} />
              <Dropdown.Item className={styles.dropdown_item} onClick={logout}>Sair</Dropdown.Item>
            </DropdownButton>
          )}
        </Navbar.Collapse>
      </Container>

      <Modal show={showIpssModal} onHide={handleIpssModalClose}>
        <Modal.Header closeButton>
          <Modal.Title className={styles.modal_title}><span className='text-uppercase'>Atenção</span></Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modal_body}>
          <p className={styles.modal_text}>
            Em caso de dúvidas, favor entrar em contato com o e-mail:
          </p>
          <p className={styles.modal_text}>cadastro@fesaude.niteroi.rj.gov.br</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleIpssModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCategoriaModal} onHide={handleCategoriaModalClose}>
        <Modal.Header closeButton>
          <Modal.Title className={styles.modal_title}><span className='text-uppercase'>Adicionar categoria em {diretoria}</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateCategory} noValidate>
            <Form.Group controlId="categoria">
              <Form.Label>*Categoria:</Form.Label>
              <Form.Control
                autoComplete="nope"
                className={styles.input}
                type="text"
                required
                name="categoria"
                onChange={e => setCategoria(e.target.value)}
                value={categoria}
                disabled={isLoading}
                ref={categoriaRef}
              />
            </Form.Group>
            <Button variant="flat" className={styles.btn} type='submit' disabled={isLoading}>
              {isLoading ? 'Salvando...' : 'Salvar'}
            </Button>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className={styles.btn_secondary} onClick={handleCategoriaModalClose}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalRefresh} onHide={handleModalRefreshClose}>
        <Modal.Header closeButton>
          <Modal.Title className={styles.modal_title}><span className='text-uppercase'>Atenção</span></Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modal_body}>
          <p className={styles.modal_text}>{refreshMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className={styles.btn_secondary} onClick={handleModalRefreshClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Navbar>
  );
};

export default Header;
